import { get } from "lodash";
import * as Yup from "yup";

export const getMeterReadingValidation = (
  key,
  name,
  message,
  isParent = false
) =>
  Yup.number()
    .required(`${name} is required`)
    .test(name, "", function () {
      const [{ value: current = null } = {}, { value: parent = null } = {}] =
        this.from || [];

      const values = isParent ? parent : current;
      if (get(values, key, "") < 0) {
        return this.createError({
          message: `${message} should be positive`,
        });
      }
      return true;
    });
